import { render } from "./CommandRow.vue?vue&type=template&id=5bb4ca22&scoped=true"
import script from "./CommandRow.vue?vue&type=script&lang=js"
export * from "./CommandRow.vue?vue&type=script&lang=js"

import "./CommandRow.vue?vue&type=style&index=0&id=5bb4ca22&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb4ca22"]])

export default __exports__